import { useContext, useEffect } from 'react';

import { ModalContext } from './ModalContext'

export function useModal() {
  const modalContext = useContext(ModalContext)

  useEffect(() => {
    return () => {
      modalContext.hideModal()
    }
  }, [])

  return modalContext
}
